import { useMemo } from 'react';
import { State } from 'store/types';
import { useStoreon } from 'storeon/react';

export const SPONSORED_PRODUCTS_PLACEMENT = 'monetization_products_search';

export const useSponsoredProductsPlacementConfig = () => {
  const { model, cookies } = useStoreon<State>('model', 'cookies');
  const { rcuid, rm_session: rmSession } = cookies;

  const findExperiment = model?.experiments?.find(
    ({ internalId }) => internalId === SPONSORED_PRODUCTS_PLACEMENT,
  );

  return useMemo(() => {
    if (findExperiment && !!findExperiment.externalId && (rcuid || rmSession)) {
      return {
        active: true,
        placementId: findExperiment.externalId,
        ...(rcuid && { session: rcuid }),
        ...(!rcuid && rmSession && { link: { name: 'session' as const, value: rmSession } }),
      };
    }

    return null;
  }, [findExperiment, rcuid, rmSession]);
};
